import * as apiService from "./apiService";

const baseURL = process.env.REACT_APP_API_BASE_URL
  ? process.env.REACT_APP_API_BASE_URL
  : "https://gitcha-api.zcodemo.com/";

const DEMO_REGISTER = `${baseURL}api/v2/demo/register`;

export async function demoRegister(payload) {
  return await apiService.apiCallWithoutToken(DEMO_REGISTER, "POST", payload);
}
